import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
const FAQItem = ({
  question,
  answer
}: FAQItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 last:border-0" data-id="element-763">
      <button onClick={() => setIsOpen(!isOpen)} className="flex justify-between items-center w-full py-6 text-left focus:outline-none" data-id="element-764">
        <span className="text-lg font-semibold text-gray-900" data-id="element-765">{question}</span>
        {isOpen ? <ChevronUp className="text-gray-500 flex-shrink-0" size={20} data-id="element-766" /> : <ChevronDown className="text-gray-500 flex-shrink-0" size={20} data-id="element-767" />}
      </button>
      {isOpen && <div className="pb-6" data-id="element-768">
          <p className="text-gray-600" data-id="element-769">{answer}</p>
        </div>}
    </div>;
};
export const FAQ = () => {
  const faqs = [{
    question: 'Okay, but how is this different from ChatGPT?',
    answer: 'Look, ChatGPT is amazing at writing personalized messages—we actually use the same brain (OpenAI) in our tool. The difference? Gigi handles the entire workflow: it scales that personalization to thousands of prospects automatically, finds the right people on LinkedIn, and sends messages on your behalf. No more copying and pasting between tabs or manually sending hundreds of messages. Just set it up once and let Gigi handle the rest.'
  }, {
    question: "Will people know it's AI-generated?",
    answer: "Here's the thing—every message is genuinely different because we dig into what actually matters: their role, company, experience, and achievements. We don't just swap out names and companies (ugh). Instead, we look at real LinkedIn data to craft messages that hit home."
  }, {
    question: 'What if I hate the messages it writes?',
    answer: "You're the boss! Review and edit everything before it goes out. Think of Gigi as your really smart first draft writer—you always get the final say."
  }, {
    question: 'Can I cancel anytime?',
    answer: "Yep! No contracts, no BS. Start with the free credits, and if you love it (you will), upgrade when you're ready. Cancel anytime with zero drama."
  }, {
    question: "What about LinkedIn's terms of service?",
    answer: "We play by the rules. Our system respects LinkedIn's guidelines and rate limits. No spam, no automation abuse—just smart, personalized outreach at a human pace."
  }];
  return <div className="py-20 bg-white" data-id="element-770">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-771">
        <div className="text-center mb-16" data-id="element-772">
          <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-773">
            The "But Wait..." Section
          </h2>
          <p className="text-xl text-gray-600" data-id="element-774">
            Questions you're too cool to ask but secretly want to know
          </p>
        </div>
        <div className="bg-white rounded-xl shadow-lg border border-gray-100" data-id="element-775">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} data-id="element-776" />)}
        </div>
      </div>
    </div>;
};